module.exports = __webpack_public_path__ + "fc91763b069882fd84b2d04e679fe553.svg";